export const isMobile = process.env.PLATFORM === "mobile";
export const isDesktop = process.env.PLATFORM === "desktop";
export const isIOS = window.navigator && (
	/iPad|iPhone|iPod/i.test(window.navigator.userAgent)
	|| (navigator.appVersion && /OKCI/i.test(navigator.appVersion))
);
export const isAndroid = window.navigator && (
	/Android/i.test(window.navigator.userAgent)
	|| (navigator.appVersion && /OKCA/i.test(navigator.appVersion))
);
export const isDev = process.env.ENVIRONMENT === "dev";
export const isLocalHost = !!process.env.LOCALHOST;
export const isSpa = !!window.IS_SPA;



// WEBPACK FOOTER //
// ./src/shared/util/EnvironmentHelpers.js